import { useCallback } from 'react'
import { useErrorModal } from '../../../hooks/api/use-error-modal'
import { useUpdateShipmentMutation } from '../../../store/api/shipments-api'
import Shipment from '../../../types/api/shipment'
import { ConvertRelationFields, EndpointQueryParameters } from '../../../types/strapi/strapi'
import { useUpdateQueryData } from './use-update-query-data'

export type ShipmentUpdateData = Partial<ConvertRelationFields<Shipment>>

/** Сохранение без пересчёта отгрузки — для флагов, не влияющих на расчёт */
export function useUpdateShipmentFields(queryArg: EndpointQueryParameters) {
    const [updateShipment, state] = useUpdateShipmentMutation()
    const updateQueryData = useUpdateQueryData(queryArg)

    useErrorModal(state, 'Ошибка обновления отгрузки')

    return useCallback(
        async (record: Shipment, data: ShipmentUpdateData) => {
            try {
                const res = await updateShipment({
                    docId: record.documentId,
                    body: { data },
                    queryParams: { populate: queryArg.populate },
                })

                if (res.data) {
                    updateQueryData(res.data.data)
                }
            } catch {
                // ошибка обрабатывается хуком useErrorModal
            }
        },
        [updateShipment, queryArg.populate, updateQueryData]
    )
}
